function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}


function toggleCartBubbleVisibility(className = ".cart-count-bubble") {
    let element = document.querySelector(className);
    let value = element.textContent.trim();

    if (value == "0") {
        element.classList.add("newhidden");
    } else {
        element.classList.remove("newhidden");
    }
}
function toggleWishlistBubbleVisibility(className = ".wishlist-count-bubble") {
    let element = document.querySelector(className);
    if (element) { // check if element exists
        let value = element.textContent.trim();
        if (value == "0" || value == "") {
            element.classList.add("newhidden");
        } else {
            element.classList.remove("newhidden");
        }
    }
}

function toggleCompareBubbleVisibility(className = ".compare-count-bubble") {
    let element = document.querySelector(className);
    if (element) { // check if element exists
        let value = element.textContent.trim();
        if (value == "0" || value == "") {
            element.classList.add("newhidden");
            document.querySelector(".cp-product-heading").style.opacity = "0";
            const fullContent = document.getElementById("compare_product");
            fullContent.classList.add("compareempty");
            fullContent.innerHTML = "<h2>Currently there are no products</h2>";
        } else {
            element.classList.remove("newhidden");
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    toggleCartBubbleVisibility();
    toggleCompareBubbleVisibility();
});

function removeExtraFadeFromOffcanvas(){ 
    let fade = document.getElementsByClassName('offcanvas-backdrop fade show')
    for (let i = 0; i < fade.length; i++) {
      while (fade.length > 1) {
        fade[i].remove()
      }
    } 
}

class Cart {
    fetchData() {
        let cartElementajax = document.querySelector(".header-icon-cart");
        if (cartElementajax.hasAttribute("cartpage")) {
            location.href = "/cart";
            return;
        }
        let myslideCart = document.querySelector("#slide-cart");
    
        const updateCart = (data) => {
            const parsedData = JSON.parse(data);
            const objectValue = parsedData["side-cart"] || parsedData["cart-main"];
            const cartInner = new DOMParser().parseFromString(objectValue,"text/html");
            let OuterCartHTML = cartInner.getElementById(myslideCart ? "slide-cart" : "my-cart").outerHTML;
            let updateCartHTML = cartInner.getElementById(myslideCart ? "slide-cart" : "my-cart").innerHTML;
            let cartElement = document.querySelector(".header-icon-cart");
            let cartCount = cartInner.getElementById(myslideCart ? "mcount" : "main-cartcount").textContent;
            cartElement.querySelector("span").textContent = cartCount;
            toggleCartBubbleVisibility();
            document.getElementById(myslideCart ? "slide-cart" : "my-cart").innerHTML = updateCartHTML;
            const scriptTags = cartInner.querySelectorAll("script");
            let combinedScript = "";
            for (let i = 0; i < scriptTags.length; i++) {
                combinedScript += scriptTags[i].textContent;
            }
            const newScript = document.createElement("script");
            newScript.textContent = combinedScript;
            if (OuterCartHTML.includes("emptyCart")) {
                localStorage.removeItem("remainingTime");
            } else {
            document.getElementById(myslideCart ? "slide-cart" : "my-cart").appendChild(newScript);
            }
            
            cartElement.querySelector("span").textContent = cartCount;
            if (myslideCart && !myslideCart.classList.contains("show")) {
                let showSidecart = new bootstrap.Offcanvas(myslideCart);
                showSidecart.show();
            }
        };

        if (myslideCart) {
            fetch("/?sections=side-cart")
                .then((response) => response.text())
                .then((data) => updateCart(data));
        } else {
            fetch("/?sections=cart-main")
                .then((response) => response.text())
                .then((data) => updateCart(data));
        }
      removeExtraFadeFromOffcanvas();
      const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);

    }
}
 
 
class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const AddClass = event.target.closest(".cart-detail, .slide-cart-body");
            AddClass.classList.add("ajax-class");
            const variantId = this.querySelector("a")
                .getAttribute("href")
                .split("id=")[1]
                .split("&")[0];
            const items = {
                id: variantId,
                quantity: 0,
            };
            const MyMainCart = AddClass.classList.contains('cart-detail') ?
                new MainCart() :
                new CartDrawer();
            MyMainCart.updateToCart(items);
        });
    }
}

customElements.define("cart-remove-button", CartRemoveButton);

class QuantityInputp extends HTMLElement {
    constructor() {
        super();
        this.minusButton = this.querySelector('.qty-mins-btn');
        this.plusButton = this.querySelector('.qty-plus-btn');
        this.inputField = this.querySelector('.cart-qty');
        this.minusButton.addEventListener('click', this.decrement.bind(this));
        this.plusButton.addEventListener('click', this.increment.bind(this));
    }

    decrement(event) {
        event.preventDefault();
        let value = parseInt(this.inputField.value, 10);
        value = value - 1;
        if (value < 1) value = 1;
        this.inputField.value = value;
    }

    increment(event) {
        event.preventDefault();
        let value = parseInt(this.inputField.value, 10);
        value = value + 1;
        this.inputField.value = value;
    }
}

customElements.define('quantity-input', QuantityInputp);

class CollectionPopUP extends HTMLElement {
    constructor() {
        super();
        let errorMessageWrapper = this.querySelector(".product-form__error-message-wrapper");
        let errorMessage = errorMessageWrapper.querySelector(".product-form__error-message");
        let wishlistbutton = this.querySelector(".wishlist");
        if (wishlistbutton){      
        let wishlistpage = wishlistbutton.closest(".wishlist-product");
        if (wishlistpage) {
            wishlistbutton.querySelector(".icon-heart").style.display = "none";
            wishlistbutton.querySelector(".showonWishlist").style.display = "block";
        }
        }
        let button = this.querySelector(".collection-popup");
        let ajxcartbutton = this.querySelector(".expresscart");  
        button?.addEventListener("click", (event) => {
            event.preventDefault();
            button.classList.add("show");
            const PopupWindow = event.target.closest("body").querySelector("#quickView");
            PopupWindow.style.cssText = "opacity: 0;";
            const productListBlock = event.target.closest(".product-list-item").querySelector(".product-list-block");
            const url = productListBlock.getAttribute("data-url");
            const searchParams = new URLSearchParams();
            searchParams.set("sections", "quick-product-view");
            const fetchUrl = `${url}?${searchParams}`;
            fetch(fetchUrl)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const ProductData = JSON.parse(data);                  
                    const MpopupObjectValue = ProductData["quick-product-view"];
                    var ProducttInner = new DOMParser().parseFromString(MpopupObjectValue,"text/html");                  
                    const UpdatePoup = ProducttInner.getElementById("shopify-section-quick-product-view").innerHTML;
                    document.getElementById("my-div").innerHTML = UpdatePoup;
                    button.classList.remove("show");
                    PopupWindow.style.cssText = "opacity: 1;display: block;";
                    var collectionpop = document.querySelector("#quickView");
                    var Mycollectionmodal =bootstrap.Modal.getOrCreateInstance(collectionpop);
                    //Mycollectionmodal.toggle();
                    Mycollectionmodal.show();
                });
        });     
         
        ajxcartbutton?.addEventListener("click", (event) => {
            event.preventDefault();
            ajxcartbutton.classList.add("show");
            const AddtoCartAjaxBlock = event.target.closest(".product-list-item");
            const AjxVarintId = parseInt(AddtoCartAjaxBlock.getAttribute("variant-rid"));
            let ajaxformData = new FormData();
            ajaxformData.append("form_type", "product");
            ajaxformData.append("utf8", "✓");
            ajaxformData.append("id", AjxVarintId);
             if(this.querySelector('quantity-input')){            
          let quant =  this.querySelector('.cart-qty ').value;            
             ajaxformData.append("quantity", quant);
          }else{
             ajaxformData.append("quantity", 1);
          }
            let config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];
            config.body = ajaxformData;
            fetch(`${window.Shopify.routes.root}cart/add`, config)
                .then((response) => {
                    return response.json();
                })
                .then(function(response) {
                    if (response.status) {
                        errorMessageWrapper.toggleAttribute("hidden");
                        if (errorMessageWrapper) {
                            if (errorMessage) {
                                errorMessage.textContent = response.description;
                            }
                        }

                        ajxcartbutton.classList.remove("show");
                        ajxcartbutton.disabled = true;
                    } else {
                        errorMessageWrapper.setAttribute("hidden", "");
                        let cartAjax = new Cart();
                        cartAjax.fetchData();
                        
                        ajxcartbutton.classList.remove("show");
                    }
                })
                .then(function(item) {})
                .catch(function(error) {});
        });
  
        const swatches = this.querySelectorAll(".collectionvariant");
        swatches.forEach((swatches) => {
            swatches.addEventListener("change", this.handleOptionChange.bind(this));
        });
    }
    handleOptionChange(event) {
        const selectedOptions = [];
        const MyClosesetSwatches = event.target.closest(".product-list-item").querySelectorAll(".collectionvariant");
        const MyJsonProudctObject = event.target.closest(".product-list-item").getAttribute("data-variants");
        MyClosesetSwatches.forEach((MyClosesetSwatches) => {
            if (MyClosesetSwatches.checked) {
                selectedOptions.push(MyClosesetSwatches.value);
            }
        });
        const selectedVariation = JSON.parse(MyJsonProudctObject).find(
            (variation) => {
                return (
                    JSON.stringify(variation.options) === JSON.stringify(selectedOptions)
                );
            }
        );
        if (selectedVariation && selectedVariation.featured_media) {
            this.querySelector(".updatimage").srcset = selectedVariation.featured_image.src;
        }
        if (selectedVariation && selectedVariation.id) {
            let MyproducturlForvariant = this.querySelector(".product-list-block").getAttribute("data-url");
            fetch(`${MyproducturlForvariant}?variant=${selectedVariation.id}&section_id=api-collection-tag-data`)
                .then((response) => response.text())
                .then((responseText) => {
                    let mytagdata = new DOMParser().parseFromString(responseText,"text/html");
                    let myotherdata = mytagdata.querySelector("#badgedata").innerHTML;
                    let mybadgeElement = this.querySelector(".myupdatebadge");
                     mybadgeElement.innerHTML = myotherdata;
                    let myPriceUpdata = mytagdata.querySelector(".product-list-price-review").innerHTML;
                    let myPricedata = this.querySelector(".product-list-price-review");                  
                   myPricedata.innerHTML = myPriceUpdata;
                });
        }
      let ajxcart = this.querySelector(".expresscart");
      if(ajxcart){
        if (selectedVariation && selectedVariation.available) {          
            this.querySelector(".expresscart").disabled = false;
          this.querySelector(".expresscart .ph-text").textContent = window.variantStrings.addToCart;
        } else {          
            this.querySelector(".expresscart").disabled = true;
          this.querySelector(".expresscart .ph-text").textContent = window.variantStrings.soldOut;
        }
        if (!selectedVariation) {  
      this.querySelector(".expresscart .ph-text").textContent = window.variantStrings.unavailable;
        }
        }
        let Mylistelement = event.target.closest(".product-list-item");
        Mylistelement.setAttribute("variant-rid", selectedVariation.id);
    
    }   
}
customElements.define("collection-popup", CollectionPopUP);

class ModelPopup extends HTMLElement {
    constructor(formId) {
        super();
        this.form = this.querySelector("form#PopupAddToCartForm");
        this.init();
        this.mylinks = this.form.querySelectorAll(".connected-size-list");
        this.dropdownMenus = this.form.querySelectorAll(".popupmmu");
        this.addToCartBtn = this.querySelector(".popupsubmitClass");
        //this.buyItNowBtn = form.querySelector('.popupbuy-now');
        this.purl = this.form.getAttribute("pro-url");
        this.dropdownMenus.forEach((dropdownMenu) => {
            dropdownMenu.addEventListener(
                "change",
                this.handleOptionChange.bind(this)
            );
        });
         this.mylinks.forEach((mylink) => {
            mylink.addEventListener(
                "click",
                this.mylinkclick.bind(this)
            );
        });
        this.popupmain = new Splide(".product-main-slider-popup", {
            type: "fade",
            pagination: false,
            arrows: false,
            cover: true,
        });

        this.thumbnailspopup = new Splide(".product-thumbnail-slider-popup", {
            perPage: 4,
            rewind: true,
            isNavigation: true,
            gap: 10,
            arrows: true,
            focus: "center",
            pagination: false,
            cover: true,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
            breakpoints: {
                640: {
                    fixedWidth: 66,
                    fixedHeight: 38,
                },
            },
        });
        this.popupmain.sync(this.thumbnailspopup);
       
    this.popupmain.mount();
        this.thumbnailspopup.mount();
      console.log(this.mylink)
    }
   mylinkclick(event){
     event.preventDefault()
     console.log("mylink clicked")
     const url = event.target.href;
            const searchParams = new URLSearchParams();
            searchParams.set("sections", "quick-product-view");
            const fetchUrl = `${url}?${searchParams}`;
      const newfetchUrl = fetchUrl.replace("collections", "products");
       fetch(newfetchUrl)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const ProductData = JSON.parse(data);                  
                    const MpopupObjectValue = ProductData["quick-product-view"];
                    let ProducttInner = new DOMParser().parseFromString(MpopupObjectValue,"text/html");                  
                    const UpdatePoup = ProducttInner.getElementById("shopify-section-quick-product-view").innerHTML;
                  console.log(UpdatePoup)
                    document.getElementById("my-div").innerHTML = UpdatePoup;
                    //button.classList.remove("show");
                    //PopupWindow.style.cssText = "opacity: 1;display: block;";
                    var collectionpop = document.querySelector("#quickView");
                   
                    //Mycollectionmodal.toggle();
                    //Mycollectionmodal.show();
                });
   }
  
    handleOptionChange(event) {
        const selectedOptions = [];
        this.dropdownMenus.forEach((dropdownMenu) => {
            if (dropdownMenu.type === "radio") {
                if (dropdownMenu.checked) {
                    selectedOptions.push(dropdownMenu.value);
                }
            } else {
                selectedOptions.push(dropdownMenu.value);
            }
        });
        this.updateButtonStatus(false);
        const selectedVariation = JSON.parse(this.form.dataset.variants).find(
            (variation) => {
                return (
                    JSON.stringify(variation.options) === JSON.stringify(selectedOptions)
                );
            }
        );
       
        if (selectedVariation) {
            this.updateButtonStatus(selectedVariation);
        }
        const removeSpaces1 = (str) => str.replace(/\s/g, "");
         if (selectedVariation){
        fetch(`${this.purl}?variant=${selectedVariation.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                let popupHtml = new DOMParser().parseFromString(responseText,"text/html");
                let myotherdata = popupHtml.querySelector("#price-quick-product-view").innerHTML;
              
                this.querySelector("#price-quick-product-view").innerHTML = myotherdata;
                let myAddtocartbuttonstatus = popupHtml.querySelector(".popupsubmitClass");
                if (myAddtocartbuttonstatus.disabled) {
                  this.querySelector(".popupsubmitClass .popupAddCarttext").textContent = window.variantStrings.soldOut;
                    this.querySelector(".popupsubmitClass").setAttribute("disabled", true);
                } else {
                    this.querySelector(".popupsubmitClass").removeAttribute("disabled", false);
                  this.querySelector(".popupsubmitClass .popupAddCarttext").textContent = window.variantStrings.addToCart;
                }
                
            });
         }
        if (selectedVariation && selectedVariation.featured_media) {
            this.popupmain.go(selectedVariation.featured_media.position - 1);
        }
      
      if (!selectedVariation){        
        this.querySelector(".popupsubmitClass .popupAddCarttext").textContent = window.variantStrings.unavailable;
        this.querySelector(".popupsubmitClass").setAttribute("disabled", true);
      }
    
    }
    updateButtonStatus(selectedVariation) {
        if (selectedVariation) {            
            this.form.querySelector("input[name=id]").value = selectedVariation.id;
        }
    }
  
    init() {
        this.form.addEventListener("submit", (evt) => {
            evt.preventDefault();
            this.addToCartBtn.classList.add("popupshow");
            let formData = new FormData(this.form);
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];
            config.body = formData;
            fetch(`${window.Shopify.routes.root}cart/add`, config)
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    if (response.status) {
                        this.errorMessageWrapper =
                            this.errorMessageWrapper ||
                            this.querySelector(".product-form__error-message-wrapper");
                        if (!this.errorMessageWrapper) return;
                        this.errorMessage = this.errorMessageWrapper.querySelector(".product-form__error-message");
                        this.errorMessageWrapper.toggleAttribute("hidden",!this.errorMessage);
                        if (this.errorMessageWrapper) {
                            this.errorMessage = this.errorMessageWrapper.querySelector(".product-form__error-message");
                            if (this.errorMessage) {
                                this.errorMessage.textContent = response.description;
                            }
                          this.addToCartBtn.classList.remove("popupshow");
                        }
                    } else {
                        let collectionpop = document.querySelector("#quickView");
                        let Mycollectionmodal =
                            bootstrap.Modal.getOrCreateInstance(collectionpop);
                        Mycollectionmodal.hide();
                        let cartAjax = new Cart();
                        cartAjax.fetchData();
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    }
}
customElements.define("model-popup", ModelPopup);

class FeaturedProduct extends HTMLElement {
    constructor() {
        super();
        this.Variants = this.querySelectorAll(".featuredopitons");      
        this.form = this.querySelector("form");
        this.purl = this.getAttribute("pro-url");      
        this.addToCartBtn = this.querySelector(".submitClass");
        this.buyItNowBtn = this.querySelector(".buy-now");
        this.form.addEventListener("submit", this.onSubmit.bind(this));
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.addEventListener("change", this.variantChange);
    }
  
    variantChange(event) {
      
        const selectedOptions = [];
        this.Variants.forEach((Variants) => {
            if (Variants.type === "radio") {
                if (Variants.checked) {
                    selectedOptions.push(Variants.value);
                }
            } else {
                selectedOptions.push(Variants.value);
            }
        });
        this.currentVariant = JSON.parse(this.dataset.product).find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return selectedOptions[index] === option;
                })
                .includes(false);
        });
      const paymentButton = this.form.querySelector(".shopify-payment-button__button");
        if (this.currentVariant && this.currentVariant.available) {
            paymentButton?.removeAttribute('disabled');
        }else{
          paymentButton?.setAttribute('disabled', 'disabled');
        }
      
        if (this.currentVariant && this.currentVariant.available) {
          this.querySelector(".submitClass .AddCarttext").textContent = window.variantStrings.addToCart;
         this.querySelector(".submitClass").removeAttribute('disabled');
          }else{
           this.querySelector(".submitClass .AddCarttext").textContent = window.variantStrings.soldOut;
         this.querySelector(".submitClass").setAttribute("disabled", true);
        }
       
        if (this.currentVariant && this.currentVariant.id) {
            this.form.querySelector("input[name=id]").value = this.currentVariant.id;
        }
       if (this.currentVariant && this.currentVariant.featured_media) {
          let mysplide = this.closest('.featured-product').querySelector('.splide--nav .splide__list');
         if(mysplide){
          let length =  mysplide.querySelectorAll('.splide__slide').length;
          let slides = mysplide.querySelectorAll(".splide__slide");       
         let number = this.currentVariant.featured_media.position - 1;
         var event = new MouseEvent("click", {bubbles: true,cancelable: true, view: window });
         slides[number].dispatchEvent(event);
         }  
        }
        if (this.currentVariant) {
            const removeSpaces = (str) => str.replace(/\s/g, "");
            fetch(`${this.purl}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then((response) => response.text())
                .then((responseText) => {
                    let picehtml = new DOMParser().parseFromString(responseText,"text/html");
                    let picehtmlprice = new DOMParser().parseFromString(responseText,"text/html");
                    let PricedataProductPage = picehtml.querySelector(`#price-${this.dataset.section}`).innerHTML;
                    document.querySelector(`#price-${this.dataset.section}`).innerHTML =PricedataProductPage;
                  // let myAddtocartbutton = picehtml.querySelector(".submitClass").outerHTML;
                  
                  
                });
        }
       
    }
    onSubmit(event) {
        event.preventDefault();
        let formData = new FormData(this.form);
        this.addToCartBtn.classList.add("show");
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = formData;
        fetch(`${window.Shopify.routes.root}cart/add`, config)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
              if (response.status) {
               this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
                        if (!this.errorMessageWrapper) return;
                        this.errorMessage = this.errorMessageWrapper.querySelector(".product-form__error-message");
                        this.errorMessageWrapper.toggleAttribute("hidden",!this.errorMessage);
                        if (this.errorMessageWrapper) {
                            this.errorMessage = this.errorMessageWrapper.querySelector(".product-form__error-message");
                            if (this.errorMessage) {
                                this.errorMessage.textContent = response.description;
                            }
                        }
                    } else {
                let cartElement1 = document.querySelector(".header-icon-cart");                
                let cartAjax = new Cart();
                cartAjax.fetchData();
            }
               this.addToCartBtn.classList.remove("show");
            })
            .catch((e) => {
                console.error(e);
            });
    }
}
customElements.define("featured-product-form", FeaturedProduct);


/*const header = document.querySelector('.header-sticky');
const content = document.querySelector('body');
const announcent = document.querySelector('.announcement-bar');
function handleStickyHeader() {
  if (header && window.pageYOffset > header.offsetTop) {
    content.style.paddingTop =  header.offsetHeight + 'px';
    header.classList.add('sticky-header-active');
  } else {
    content.style.paddingTop = 0;
    if (header) {
      header.classList.remove('sticky-header-active');
    }
  }
}

window.addEventListener('scroll', handleStickyHeader);
*/
const header = document.querySelector('.header-sticky');
const headerheight =  header.offsetHeight
const content = document.querySelector('body');
const announcent = document.querySelector('.announcement-bar');
function handleStickyHeader() {
  
  if (header && window.pageYOffset > header.offsetTop) {
    content.style.paddingTop =  headerheight + 'px';
    header.classList.add('sticky-header-active');
  } else {
    content.style.paddingTop = 0;
    if (header) {
      header.classList.remove('sticky-header-active');
    }
  }
}

window.addEventListener('scroll', handleStickyHeader);

const swatchContainer = document.querySelector(".vaiant-swatch-block-detail");
document.body.addEventListener("click", function(e) {
    if (e.target.matches(".showremaningvariats")) {
        const target = e.target;
        const swatchContainer = e.target.closest(".vaiant-swatch-block-detail");
        const swatches = swatchContainer.querySelectorAll(".variant-swatch-box:not(.visible)");
        swatches.forEach(function(swatch) {
            swatch.style.display = "inline-block";
        });
        target.style.display = "none";
    }
    if (e.target.matches(".RecentAddtoCart")) {
        const RecentProduct = e.target;
        let MyVariantId = RecentProduct.getAttribute("val");
        let RecenTproductData = new FormData();
        RecenTproductData.append("form_type", "product");
        RecenTproductData.append("utf8", "✓");
        RecenTproductData.append("id", MyVariantId);
        RecenTproductData.append("quantity", 1);
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = RecenTproductData;
        fetch(`${window.Shopify.routes.root}cart/add`, config)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (response.status) {
                    alert(response.description);
                } else {
                    let cartAjax = new Cart();
                    cartAjax.fetchData();
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }
    if (e.target.matches(".SelectOption")) {
        let goToProduct = e.target;
        let MyProductUrl = goToProduct.getAttribute("href");
        let VariantUrl = `${location.origin}${MyProductUrl}`;
        location.href = VariantUrl;
    }
});

// comparison modal popup

var comparisonArray;

if (localStorage.getItem("comparisonArray")) {
    comparisonArray = JSON.parse(localStorage.getItem("comparisonArray"));
    let compareElement = document.querySelector(".compare-count-bubble");
    if (document.contains(compareElement)) {
        compareElement.querySelector("span").textContent = comparisonArray.length;
    }
} else {
    comparisonArray = [];
}


document.addEventListener("click", function(event) {
    if (event.target.classList.contains("comparison")) {
        var input = event.target;
        if (input.checked) {
            if (comparisonArray.length === 5) {
                var removedValue = comparisonArray.shift();
                var removedCheckbox = document.querySelector('.comparison[value="' + removedValue + '"]');
                removedCheckbox.checked = false;
                //console.log("Removed value:", removedValue);
            }
            if (!comparisonArray.includes(input.value)) {
                comparisonArray.push(input.value);
                localStorage.setItem("comparisonArray",JSON.stringify(comparisonArray));
                //console.log("Added value:", input.value);
            }
        } else {
            comparisonArray = comparisonArray.filter(function(value) {
                return value !== input.value;
            });
            localStorage.setItem("comparisonArray", JSON.stringify(comparisonArray));
            console.log("Removed value:", input.value);
            console.log(comparisonArray);
        }
        let compareElement = document.querySelector(".compare-count-bubble");
        //compareElement.querySelector("span").textContent = comparisonArray.length;
        if (document.contains(compareElement)) {
        compareElement.querySelector("span").textContent = comparisonArray.length;
        }
        toggleCompareBubbleVisibility();
        // console.log("Current comparisonArray:", comparisonArray);
    }
});
document.querySelectorAll(".comparison").forEach(function(input) {
    if (comparisonArray.includes(input.value)) {
        input.checked = true;
    }
});

function checkComparisonValues(comparisonArray) {
    console.log(comparisonArray)
    document.querySelectorAll(".comparison").forEach(function(input) {
        if (comparisonArray.includes(input.value)) {
            input.checked = true;
        }
    });
}

const compareModal = document.querySelector(".compare-modal");
if (compareModal) {
//document.querySelector(".compare-modal").addEventListener("click", function() {
 compareModal.addEventListener("click", function() {
    const comapreHtml = [];
    var comparisonArray = JSON.parse(localStorage.getItem("comparisonArray"));
    if (comparisonArray.length === 0) {
        var myModalEl = document.querySelector("#compareModal");
        var modal = bootstrap.Modal.getOrCreateInstance(myModalEl); // Returns a Bootstrap modal instance
        modal.show();
        document.querySelector(".cp-product-heading").style.opacity = "0";
        const fullContent = document.getElementById("compare_product");
        fullContent.classList.add("compareempty");
        fullContent.innerHTML = "<h2>Currently there are no products</h2>";
        return;
    }
    document.querySelector(".cp-product-heading").style.opacity = "1";
    comparisonArray.forEach((item) => {
        const compareutl = `/products/${item}?view=compare`;
        comapreHtml.unshift(
            fetch(compareutl)
            .then((res) => res.text())
            .then((res) => {
                const text = res;
                const parser = new DOMParser();
                const comparehtmlDocument = parser.parseFromString(text, "text/html");
                const compareProductCard =
                    comparehtmlDocument.documentElement.querySelector(".mycomparetable");
                return compareProductCard.outerHTML;
            })
            .catch((err) => {
                console.error(err);
                // Remove invalid handle from comparisonArray
                const index = comparisonArray.indexOf(item);
                if (index > -1) {
                    comparisonArray.splice(index, 1);
                }
            })
        );
    });
    Promise.all(comapreHtml)
        .then((res) => {
            // Check if comparisonArray is empty
            if (comparisonArray.length === 0) {
                const fullContent = document.getElementById("compare_product");
                fullContent.classList.add("compareempty");
                fullContent.innerHTML = "<h2>No products to compare</h2>";
                return;
            }
            const newCompareData = res.join("");
            const fullContent = document.getElementById("compare_product");
            fullContent.innerHTML = newCompareData;
            fullContent.classList.remove("compareempty");
            var myModalEl = document.querySelector("#compareModal");
            var modal = bootstrap.Modal.getOrCreateInstance(myModalEl); // Returns a Bootstrap modal instance
            modal.toggle();
            // Update comparisonArray in localStorage
            localStorage.setItem("comparisonArray", JSON.stringify(comparisonArray));
        })
        .catch((err) => {
            console.error(err);
        });
});
}


const comparisonInputs = document.querySelectorAll(".comparison");
document.body.addEventListener("click", function(e) {
    if (e.target.matches(".removecomparison")) {
        const value = e.target.getAttribute("value");
        comparisonArray.splice(comparisonArray.indexOf(value), 1);
        localStorage.setItem("comparisonArray", JSON.stringify(comparisonArray));
        e.target.closest(".mycomparetable").remove();
        for (let i = 0; i < comparisonInputs.length; i++) {
            const input = comparisonInputs[i];
            console.log(input);
            input.checked = comparisonArray.includes(input.value);
        }
        let compareElement = document.querySelector(".compare-count-bubble");
        compareElement.querySelector("span").textContent = comparisonArray.length;
        toggleCompareBubbleVisibility();
    }
});

// compare modal variant change functionality and corresponding functions

class CompareAddToCart extends HTMLElement {
    constructor() {
        super();
        this.image = this.closest(".mycomparetable");
        this.Variants = this.querySelectorAll(".compareopitons");
        this.addToCartBtn = this.querySelector(".comapresubmit");
        this.addEventListener("change", this.onChange);
        this.variantsdata = this.getAttribute("data-variants");
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmit.bind(this));
        this.submitButton = this.form.querySelector('[type="submit"]');
    }
    onChange(event) {
        const selectedOptions = [];
        this.Variants.forEach((Variants) => {
            if (Variants.type === "radio") {
                if (Variants.checked) {
                    selectedOptions.push(Variants.value);
                }
            } else {
                selectedOptions.push(Variants.value);
            }
        });
        this.currentVariant = JSON.parse(this.variantsdata).find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return selectedOptions[index] === option;
                })
                .includes(false);
        });
        
        if (this.currentVariant) {
            this.setAttribute("compare-id", this.currentVariant.id);
        }
        if (this.currentVariant && this.currentVariant.available) {            
            this.submitButton.disabled = false;
        } else {
            this.submitButton.disabled = true;
        }

        if (this.currentVariant.featured_image) {
            let imgcompar = this.image.querySelector(".compareimage");
            imgcompar.src = this.currentVariant.featured_image.src;
        }
    }
    onSubmit(event) {
        event.preventDefault();
        let ComapreProductId = this.getAttribute("compare-id");
        let CompareproductData = new FormData();
        CompareproductData.append("form_type", "product");
        CompareproductData.append("utf8", "✓");
        CompareproductData.append("id", ComapreProductId);
        CompareproductData.append("quantity", 1);
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        console.log(config);
        config.body = CompareproductData;
        fetch(`${window.Shopify.routes.root}cart/add`, config)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (response.status) {
                    alert(response.description);
                } else {
                    var myModalEl = document.querySelector("#compareModal");
                    var modal = bootstrap.Modal.getOrCreateInstance(myModalEl);
                    modal.toggle();
                    let cartAjax = new Cart();
                    cartAjax.fetchData();
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }
}
customElements.define("compare-product-form", CompareAddToCart);

//Cart timer functionality

class CartTimer extends HTMLElement {
    constructor() {
        super();
        this.timerId = null;
    }
    static get observedAttributes() {
        return ["minutes"];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "minutes") {
            this.minutes = parseInt(newValue, 10);
        }
    }
    connectedCallback() {
        this.checkCart();
        this.listenToCartChanges();
    }
    disconnectedCallback() {
        localStorage.removeItem("remainingTime");
        clearInterval(this.timerId);
    }
    listenToCartChanges() {
        Shopify.onCartUpdate = function(cart) {
            clearInterval(this.timerId);
            this.checkCart();
        };
    }
    checkCart() {
        let remainingTime = localStorage.getItem("remainingTime");
        if (!remainingTime || window.cart.item_count == 0) {
            remainingTime = this.minutes * 60; // convert minutes to seconds
            localStorage.setItem("remainingTime", remainingTime);
        }
        this.startTimer(remainingTime);
    }

    async startTimer(remainingTime) {
        this.timerId = setInterval(() => {
            if (remainingTime <= 0) {
                clearInterval(this.timerId);
                this.innerHTML = "Time is up!";
                localStorage.removeItem("remainingTime");
                fetch("/cart/clear.js")
                    .then((response) => response.json())
                    .then((data) => {
                        let cartAjax = new Cart();
                        cartAjax.fetchData();
                    });
            } else {
                const minutes = Math.floor(remainingTime / 60);
                const seconds = remainingTime % 60;
                //this.innerHTML = `Time remaining: ${minutes}:${("0" + seconds).slice(-2)}`;
                this.querySelector("#timer").innerHTML = `${minutes}:${(
          "0" + seconds
        ).slice(-2)}`;
                remainingTime--;
                localStorage.setItem("remainingTime", remainingTime);
            }
        }, 1000);
    }
}

customElements.define("cart-timer", CartTimer);


// Terms and condtions checbox for the checkout button

document.addEventListener("DOMContentLoaded", function() {
    document.body.addEventListener("click", function(event) {
        if (event.target.getAttribute("name") === "checkout") {
            if (document.getElementById("agree").checked) {
                event.target.submit();
            } else {
                //alert("You must agree with the terms and conditions of store to check out.");
                let Addclasscheckbox = document.getElementById("checkoutshow");
                Addclasscheckbox.classList.add("errorcheckout");
                event.preventDefault();
            }
        }
    });
});

document.querySelector("body").addEventListener("change", function(evt) {
    if (event.target.name === "attributes[cart-note]") {
        var note = evt.target.value;
        var headers = new Headers({
            "Content-Type": "application/json"
        });
        var request = {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                attributes: {
                    "cart-note": note
                }
            }),
        };
        fetch("/cart/update.js", request);
    }
});

// add and remove funtionality on click for gift wrap

document.querySelector("body").addEventListener("change", function(event) {
    if (event.target.name === "attributes[gift-wrapping]") {
        if (event.target.checked) {
            let AddClass =
                event.target.closest(".slide-cart-body") ||
                event.target.closest(".cart-detail");
            AddClass.classList.add("ajax-class");
            Shopify.Cart.GiftWrap.set();
        } else {
            let AddClass =
                event.target.closest(".slide-cart-body") ||
                event.target.closest(".cart-detail");
            AddClass.classList.add("ajax-class");
            Shopify.Cart.GiftWrap.remove();
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

  if ("IntersectionObserver" in window) {
    
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");          
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function(lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});


class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.variantRid = this.getAttribute('variant-rid');
    this.quantity = this.getAttribute('quantity') || 1;
    this.submitButtonSelector = this.querySelector('.mycartupsellsubmit');
     const swatches = this.querySelectorAll(".upsell-variant");
        swatches.forEach((swatches) => {
            swatches.addEventListener("change", this.handleOptionChange.bind(this));
        });
   let showvariant = this.querySelector(".mycartupshowoption");
showvariant?.addEventListener("click", (event) => {
  //let addclassvaroamt = this.querySelector(".cart-options");
 // addclassvaroamt.classList.toggle("cart-show");
   event.preventDefault();
            const PopupWindow = event.target.closest("body").querySelector("#quickView");
            PopupWindow.style.cssText = "opacity: 0;";
            const productListBlock = event.target.closest(".cart-upsell-list");
            const url = productListBlock.getAttribute("data-url");
            const searchParams = new URLSearchParams();
            searchParams.set("sections", "quick-product-view");
            const fetchUrl = `${url}?${searchParams}`;
            fetch(fetchUrl)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const ProductData = JSON.parse(data);                  
                    const MpopupObjectValue = ProductData["quick-product-view"];
                    var ProducttInner = new DOMParser().parseFromString(MpopupObjectValue,"text/html");                  
                    const UpdatePoup = ProducttInner.getElementById("shopify-section-quick-product-view").innerHTML;
                    document.getElementById("my-div").innerHTML = UpdatePoup;
                    
                    PopupWindow.style.cssText = "opacity: 1;display: block;";
                    var collectionpop = document.querySelector("#quickView");
                    var Mycollectionmodal =bootstrap.Modal.getOrCreateInstance(collectionpop);
                    //Mycollectionmodal.toggle();
                    Mycollectionmodal.show();
                });
});

    let cartajax = this.querySelector(".mycartupsellsubmit");  
      cartajax?.addEventListener("click", (event) => {
            event.preventDefault();
         let AddClass = event.target.closest(".slide-cart-body") || event.target.closest(".cart-detail");
            AddClass.classList.add("ajax-class");
            cartajax.classList.add("show");
            let AddtoCartAjaxBlock = event.target.closest(".cart-upsell-list");
            let AjxVarintId = parseInt(AddtoCartAjaxBlock.getAttribute("variant-rid"));            
            let ajaxformData = new FormData();
            ajaxformData.append("form_type", "product");
            ajaxformData.append("utf8", "✓");
            ajaxformData.append("id", AjxVarintId);
             if(this.querySelector('quantity-input')){            
          let quant =  this.querySelector('.cart-qty ').value;            
             ajaxformData.append("quantity", quant);
          }else{ajaxformData.append("quantity", 1);}
            let config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];
            config.body = ajaxformData;
            console.log(config.body)
            fetch(`${window.Shopify.routes.root}cart/add`, config)
                .then((response) => {
                    return response.json();
                })
                .then(function(response) {
                  
                    if (response.status) {
                        errorMessageWrapper.toggleAttribute("hidden");
                        if (errorMessageWrapper) {
                            if (errorMessage) {
                                errorMessage.textContent = response.description;
                            }
                        }

                        ajxcartbutton.classList.remove("show");
                        ajxcartbutton.disabled = true;
                    } else {
                      console.log("response")
                      let cartAjax = new Cart();
                        cartAjax.fetchData();
                        errorMessageWrapper.setAttribute("hidden", "");
                       
                        ajxcartbutton.classList.remove("show");
                    }
                })
                .then(function(item) {})
                .catch(function(error) {});
        });
  }
        handleOptionChange(event) {
        const selectedOptions = [];
        const MyClosesetSwatches = event.target.closest(".cart-upsell-list").querySelectorAll(".upsell-variant");
        const MyJsonProudctObject = event.target.closest(".cart-upsell-list").getAttribute("data-variants");
        MyClosesetSwatches.forEach((MyClosesetSwatches) => {
            if (MyClosesetSwatches.checked) {
                selectedOptions.push(MyClosesetSwatches.value);
            }
        });
      const selectedVariation = JSON.parse(MyJsonProudctObject).find(
            (variation) => {
                return (
                    JSON.stringify(variation.options) === JSON.stringify(selectedOptions)
                );
            }
        );
    
         if (selectedVariation && selectedVariation.available) {
            this.querySelector(".mycartupsellsubmit").disabled = false;
        } else {
            this.querySelector(".mycartupsellsubmit").disabled = true;
        }
        let Mylistelement = event.target.closest(".cart-upsell-list");
        Mylistelement.setAttribute("variant-rid", selectedVariation.id);
   }
 

  addToCart() {
    const formData = new FormData();
    formData.append('id', this.variantRid);
    formData.append('quantity', this.quantity);

}
}
customElements.define('cart-upsell', CartUpsell);

class PopUp extends HTMLElement {
 
  constructor() {
  super();
  }
    connectedCallback(){
console.log(localStorage.getItem('themePopup'))
  this.options = JSON.parse(this.getAttribute('data-section-settings'));
  this._openPopup = this.openPopup.bind(this);
// setTimeout(this._openPopup, this.options['apparitionDelay'] * 1000);
      if (Shopify.designMode) {
        this._openPopup();
      }
  try {
    
    if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
      this._openPopup();
    } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
      setTimeout(this._openPopup, this.options['apparitionDelay'] * 1000);
    }
  } catch (error) {
   }
    const closeButton = this.querySelector('.NewsletterPopup__Close');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      this.setAttribute('aria-hidden', 'true');
    });
  }
}

   openPopup() {   
    this.setAttribute('aria-hidden', 'false');
    localStorage.setItem('themePopup', 'true');
    
  } 

}
customElements.define('popup-aside', PopUp);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

 getSearchResults(searchTerm) {
  fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
    const SearchLengh = resultsMarkup.querySelectorAll('.predictive-search__list-item').length;
      
      if (SearchLengh > 1) {     
        this.predictiveSearchResults.innerHTML = resultsMarkup.innerHTML;
        const scriptTags = resultsMarkup.querySelectorAll("script");
            let combinedScript = "";
            for (let i = 0; i < scriptTags.length; i++) {
                combinedScript += scriptTags[i].textContent;
            }
        const newScript = document.createElement("script");
            newScript.textContent = combinedScript;
        this.predictiveSearchResults.appendChild(newScript)
        
        this.open();
      } else {
        this.predictiveSearchResults.innerHTML = '<p class="no result">No results found</p>';
        this.open();
      }
    })
    .catch((error) => {
      this.close();
      throw error;
    });
}


  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.innerHTML = ' ';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
